/* eslint-disable camelcase */
import { z } from 'zod'

import {
  GetMeetingObservabilityMeetingsLabelRuleEnum,
  GetMeetingObservabilityMeetingsLabelSourceEnum,
} from './generated/api'

export type AttributionLabelSource = GetMeetingObservabilityMeetingsLabelSourceEnum
export type AttributionLabelRule = GetMeetingObservabilityMeetingsLabelRuleEnum
export const attributionLabelSources = Object.values(GetMeetingObservabilityMeetingsLabelSourceEnum) as [
  AttributionLabelSource,
  ...AttributionLabelSource[],
]
export const attributionLabelRules = Object.values(GetMeetingObservabilityMeetingsLabelRuleEnum) as [
  AttributionLabelRule,
  ...AttributionLabelRule[],
]

export type AttributionSourceSelection = {
  label_source: AttributionLabelSource
  label_rule?: AttributionLabelRule
}

export const labelSourceRules = {
  ax: ['dom', 'dom_contested', 'rescue', 'unknown'],
  channel: [
    'mic_content_owner',
    'mic_sole_speaker_owner',
    'system_content_attendee',
    'paired_sole_attendee',
    'unknown',
  ],
  llm: [
    'roster_calendar',
    'roster_other',
    'naming_link_calendar',
    'naming_link_other',
    'naming_created',
    'prior',
    'unknown',
  ],
  unnamed: [],
} as const satisfies Record<AttributionLabelSource, readonly AttributionLabelRule[]>

const sourceCount = z.number().nonnegative().int().max(Number.MAX_SAFE_INTEGER)
const knownLabelSourcesSchema = z.object({
  measured_meetings: sourceCount,
  unmeasured_meetings: sourceCount,
  active_speakers: sourceCount,
  sources: z.array(
    z.object({
      source: z.enum(attributionLabelSources),
      speakers: sourceCount,
      meetings: sourceCount,
      evaluation: z
        .object({
          evaluated_speakers: sourceCount,
          claimed_speakers: sourceCount,
          measured_meetings: sourceCount,
          evaluated_meetings: sourceCount,
        })
        .nullable()
        .default(null),
      rules: z.array(
        z.object({
          rule: z.enum(attributionLabelRules),
          speakers: sourceCount,
          meetings: sourceCount,
        })
      ),
    })
  ),
})
export const attributionLabelSourcesSchema = knownLabelSourcesSchema
  .extend({
    sources: z.array(
      knownLabelSourcesSchema.shape.sources.element.extend({
        source: z.string(),
        rules: z.array(knownLabelSourcesSchema.shape.sources.element.shape.rules.element.extend({ rule: z.string() })),
      })
    ),
  })
  .transform((value) => {
    const parsed = knownLabelSourcesSchema.safeParse(value)
    if (parsed.success) return parsed.data
    console.warn('Speaker-label source vocabulary is unsupported', {
      issues: parsed.error.issues.map(({ path, code }) => ({ path, code })),
    })
    return null
  })
export type AttributionLabelSources = z.infer<typeof knownLabelSourcesSchema>
